import { render, staticRenderFns } from "./stats-header.vue?vue&type=template&id=07bc74a7&scoped=true&"
import script from "./stats-header.vue?vue&type=script&lang=js&"
export * from "./stats-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc74a7",
  null
  
)

export default component.exports